import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <SEO title="Политика за поверителност" description="Политика за поверителност на GreenCastle." url="/privacy" />
      <Header />
      <section className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl font-bold text-foreground mb-8">Политика за поверителност</h1>

          <div className="prose prose-green max-w-none text-foreground/80 space-y-6">
            <p>Последна актуализация: {new Date().getFullYear()} г.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">1. Информация, която събираме</h2>
            <p>GreenCastle събира информация, която вие ни предоставяте доброволно при попълване на форми за контакт или запитвания — имена, имейл адрес и телефонен номер.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">2. Как използваме информацията</h2>
            <p>Събраната информация се използва единствено за обработка на вашите запитвания и предоставяне на исканата информация. Не продаваме и не споделяме вашите данни с трети страни.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">3. Бисквитки (Cookies)</h2>
            <p>Сайтът използва технически необходими бисквитки за правилното му функциониране. Може да използваме и аналитични инструменти (Google Analytics) за подобряване на потребителското изживяване.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">4. Съхранение на данни</h2>
            <p>Личните ви данни се съхраняват толкова дълго, колкото е необходимо за изпълнение на целите, за които са събрани, или съгласно изискванията на приложимото законодателство.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">5. Вашите права</h2>
            <p>Имате право да поискате достъп, коригиране или изтриване на личните си данни. За упражняване на тези права, свържете се с нас на: <a href="mailto:office@greencastle.bg" className="text-[#1B5E37] hover:underline">office@greencastle.bg</a>.</p>

            <h2 className="font-heading text-2xl font-semibold text-foreground mt-8 mb-3">6. Контакт</h2>
            <p>При въпроси относно политиката за поверителност, моля свържете се с нас:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Имейл: office@greencastle.bg</li>
              <li>Телефон: +359 890 300 600</li>
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
